import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';
import { dealFormField } from '@openx/types/deal';
import { useTranslation } from 'react-i18next';

type IdGroupRadioProps = {
  disabled: boolean;
};

export const IdGroupRadio = ({ disabled = false }: IdGroupRadioProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        alignItems: 'flex-start',
        display: 'inline-flex',
        gap: 1,
        margin: 0.5,
        width: '100%',
      }}
      data-test="id-group-radio"
    >
      <Typography noWrap sx={theme => ({ marginTop: theme.spacing(0.25) })} data-test="external-deal-id-text">
        {t('Internal Deal under existing external Deal ID')}
      </Typography>

      <RHFTextField
        name={dealFormField.EXTERNAL_DEAL_ID}
        placeholder={t('[ Enter your external Deal ID ]')}
        disabled={disabled}
        sx={{
          maxWidth: 205,
          width: '100%',
        }}
        dataTest="radio-external-input"
      />
    </Box>
  );
};
